import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const empStatusSlice = createSlice({
  name: "empStatus",

  initialState: {
    status: false,
  },
  reducers: {
    seEmpStatus: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.status = payload;
    },
    resetEmpStatus: (state: any) => {
      state.status = false;
    },
  },
});

export const { seEmpStatus, resetEmpStatus } = empStatusSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default empStatusSlice.reducer;
